import { isMobile } from '@vindr/utils/mobile';

const isOutOfMaxTextureSize = instance =>
  isMobile() && (instance.Columns > 4096 || instance.Rows > 4096);

export default isOutOfMaxTextureSize;
